import React, { useState } from "react";
import * as Icon from "react-bootstrap-icons";
import { getRole } from "../../services/authenticationService";
import { CommentForm } from "../CommentForm";

type CommentData = {
	comment: string;
	poleCommentId: string;
	isResolved: boolean;
	poleAction: boolean;
	createdBy: string;
	createdOn: string;
	updatedBy: string;
	updatedOn: string;
};

type saveCommentParams = {
	comment: string;
	poleAction: boolean;
	poleCommentId: string | null;
	isResolved: boolean;
};

interface CommentsSectionProps {
	comments: CommentData[];
	poleId: unknown | string;
	onCommentSubmit: (saveCommentParams: saveCommentParams) => void;
	onCommentDelete: (saveCommentParams: saveCommentParams) => void;
}

const CommentsSection: React.FC<CommentsSectionProps> = ({
	comments,
	poleId,
	onCommentSubmit,
	onCommentDelete,
}) => {
	const [isAddComment, setIsAddComment] = useState(false);
	const [activeEditComment, setActiveEditComment] = useState<string | null>(null);
	const isViewer = getRole() === 'Viewer';
	const unresolvedComments = comments?.filter(comment => !comment.isResolved) || [];

	const handleCommentSubmit = (saveCommentParams: saveCommentParams) => {
		onCommentSubmit(saveCommentParams);
		setActiveEditComment(null);
		setIsAddComment(false);
	};

	if (!comments) return null;

	return (
		<div className="poleinfo my-2">
			<fieldset className="recommendation border rounded mt-2" id="fildset-2">
				<legend className="legend-text float-none w-auto">COMMENTS</legend>
				{!isViewer && (
					<>
						<div className="text-center mb-2">
							<a
								className="add-comment-link pointer"
								data-testid="add-comment-link"
								onClick={() => {
									setIsAddComment(!isAddComment);
									setActiveEditComment(null);
								}}
							>
								Add Comment
							</a>
						</div>
						{isAddComment && (
							<CommentForm
								data-testid="add-comment-form"
								comment={{ comment: '', poleAction: true, poleCommentId: null, isResolved: false }}
								onSubmitComment={handleCommentSubmit}
							/>
						)}
					</>
				)}

				{unresolvedComments.length > 0 ? (
					<>
						{comments.map((value, index) => (
							activeEditComment === value.poleCommentId ? (
								<CommentForm
									key={index}
									data-testid="edit-comment-form"
									comment={{
										comment: value.comment,
										poleAction: value.poleAction,
										poleCommentId: value.poleCommentId,
										isResolved: value.isResolved
									}}
									onSubmitComment={handleCommentSubmit}
									setActiveEditComment={setActiveEditComment}
								/>
							) : (
								<div key={index} className="form mx-2 mb-1" data-testid="comment-div" id="form">
									{!value.isResolved && (
										<div className={`d-flex align-items-center mb-2 pt-1 position-relative comment-div`} style={{ backgroundColor: "#ccefff" }}>
											<div className="form-controls w-100" id="form-controls" style={{ backgroundColor: "#ccefff" }}>
												<div className="form-value pe-5 text-break" data-testid="comment">{value.comment}</div>
												<div className="d-flex justify-content-between align-items-end">
													{!isViewer ? (
														<div className="form-check form-switch form-check-inline p-0">
															{/* Comment toggle removed per requirements */}
														</div>
													) : (
														<div className="pb-1" />
													)}
													<div className='label mb-1' data-testid="author-name">{value.createdBy}</div>
												</div>
											</div>
											{!isViewer && (
												<div>
													<div className="edit-icon">
														<Icon.Trash
															className="icon position-absolute pointer"
															id="icon"
															data-testid="delete-icon"
															style={{ padding: "0.5rem", top: -4, right: 24, zIndex: 4 }}
															onClick={() => onCommentDelete({
																comment: value.comment,
																poleAction: value.poleAction,
																poleCommentId: value.poleCommentId,
																isResolved: !value.isResolved
															})}
														/>
														<Icon.PencilSquare
															data-testid="edit-icon"
															className="icon position-absolute pointer"
															onClick={() => {
																setActiveEditComment(value.poleCommentId);
																setIsAddComment(false);
															}}
															id="icon"
															style={{ padding: "0.5rem", top: -4, right: -4 }}
														/>
													</div>
												</div>
											)}
										</div>
									)}
								</div>
							)
						))}
					</>
				) : (
					<div className="alert alert-warning mt-2 mx-2" role="alert" data-testid="alert-2">
						There is no comment against this pole.
					</div>
				)}
			</fieldset>
		</div>
	);
};

export default CommentsSection;

